// メール再送
import React, { useState, useEffect } from 'react';
import { render } from 'react-dom';
import Heading from '../../molecules/Heading';
import Block from '../../molecules/Block';
import TransitionButton from '../../molecules/TransitionButton';
import { handleBrowserBack } from '../../BrowserBack';
import { isBrowserIe } from '../../BrowserJudgment';
import Annotation from '../../atoms/Annotation';
import MailResendBox from '../../molecules/MailResendBox';
import Popup from '../../molecules/Popup';
import axios from '../../axios';
import LoadingModal from '../../molecules/LoadingModal';
import 'url-search-params-polyfill';

interface Guarantors {
  id: string;
  sub_no: string;
  name: string;
  email: string;
}

interface Reception {
  r_cd: string;
  r_id: string;
}

const MailResend: React.FC = () => {
  // URLパラメータ取得
  const url_params = new URLSearchParams(document.location.search.substring(1));
  const r_id = url_params.get('r_id');
  // 連帯債務者等の情報を格納する
  const [guarantors, setGuarantors] = useState<Guarantors[]>([]);
  const [reception, setReception] = useState<Reception | null>(null);
  const [modal_show, setModalShow] = useState(false);
  const [popup_button, setPopupButton] = useState({
    label: '閉じる',
    variant: 'outline-success',
    handleClick: () => handlePopupClick(),
  });

  const init_error_message = { 0: '', 1: '', 2: '', 3: '',4: '', 5: '', 6: '', 7: '',8: '', 9: '', 10: '',
                              11: '',12: '', 13: '', 14: '', 15: '' , 16: '', 17: '',18: '', 19: ''}

  const [error_message, setErrorMessage] = useState(init_error_message);
  const [is_loading, setIsLoading] = useState(false);

  useEffect(() => {
    // ブラウザの戻る・進む禁止
    handleBrowserBack();
    // 表示する連帯債務者等を取得
    getGuarantors();
  }, []);

  // 連帯債務者等の情報を取得・格納する
  const getGuarantors = async () => {
    try {
      const response = await axios.post(`${location.origin}${process.env.MIX_MOCK_URL}/applicant/api/get_guarantors`, { r_id: r_id });
      setGuarantors(response.data.guarantors);
      setReception(response.data.reception);
    } catch (error) {
      console.error(error);
    }
  };

  // メール再送ボタン押下時
  const handleClick = async (value: { [key: string]: string }, number: number) => {
    try {
      setErrorMessage({ ...error_message, [number]: '' });
      setIsLoading(true);

      const response = await axios.post(`${location.origin}${process.env.MIX_MOCK_URL}/applicant/api/resend_mail`, {
        guarantors_id: value.id,
        email: value.email,
        r_cd: reception?.r_cd,
        r_id: reception?.r_id,
      });

      // メール再送通知ポップアップを表示する
      setModalShow(true);
    } catch (error) {
      console.error(error);
      if (error.response.data.message.email) {
        setErrorMessage({ ...error_message, [number]: error.response.data.message.email[0] });
      } else {
        alert('システムエラーが発生しました');
      }
    } finally {
      setIsLoading(false);
    }
  };

  // ポップアップ内の閉じるボタン押下時
  const handlePopupClick = () => setModalShow(false);

  // 戻るボタン押下時の処理
  const backTransition = () => {
    if (isBrowserIe()) {
      const node = document.getElementById('mail-resend');
      location.replace(node?.dataset.referer as string);
    } else {
      location.replace(document.referrer);
    }
  };

  return (
    <>
      <Heading label="メール再送" size="l" />
      <Block
        label={'マイページ開設招待メールの再送'}
        content={
          <>
            <Annotation text="申込内容確認のためのマイページ開設招待メールを再送します。必要に応じてメールアドレスを変更して下さい。" />
            {guarantors.map((value: any, index: number) => {
              return (
                <MailResendBox
                  value={value}
                  number={index}
                  message={error_message}
                  handleClick={handleClick}
                  key={index}
                />
              );
            })}
            <TransitionButton label="戻る" handleClick={backTransition} />
          </>
        }
      />
      <Popup
        title="メールの再送"
        text="連帯債務者等の方に申込内容確認のためのマイページ開設招待メールを再送しました。"
        toggleShow={modal_show}
        toggleClose={handlePopupClick}
        first_button={popup_button}
      />
      <LoadingModal show={is_loading} />
    </>
  );
};

if (document.getElementById('mail-resend')) {
  render(<MailResend />, document.getElementById('mail-resend'));
}
